module.exports = __webpack_public_path__ + "img/longhair-man.36cb20f0.svg";